import React, { useState } from "react";
import { FileCode2, Trash2, ChevronRight, ChevronDown } from "lucide-react";

function Row({ name, node, depth, activePath, onOpen, onDelete, renderChildren }) {
  const [open, setOpen] = useState(depth < 2);
  if (node.__file) {
    const isActive = activePath === node.__file;
    return React.createElement(
      "div",
      {
        onClick: () => onOpen(node.__file),
        className:
          "group flex items-center gap-1 text-xs cursor-pointer py-0.5 px-1 rounded " +
          (isActive
            ? "bg-emerald-500/10 text-emerald-300"
            : "text-white/60 hover:bg-white/5"),
        style: { paddingLeft: 8 + depth * 12 },
      },
      React.createElement(FileCode2, { size: 11 }),
      React.createElement(
        "span",
        { className: "truncate flex-1 font-mono" },
        name,
      ),
      React.createElement(
        "button",
        {
          onClick: (e) => {
            e.stopPropagation();
            onDelete(node.__file);
          },
          className:
            "opacity-0 group-hover:opacity-100 text-white/40 hover:text-rose-400",
        },
        React.createElement(Trash2, { size: 10 }),
      ),
    );
  }
  const kids = Object.entries(node).sort((a, b) => a[0].localeCompare(b[0]));
  return React.createElement(
    "div",
    null,
    React.createElement(
      "div",
      {
        onClick: () => setOpen(!open),
        className:
          "flex items-center gap-1 text-xs text-white/60 py-0.5 px-1 cursor-pointer hover:bg-white/5 rounded",
        style: { paddingLeft: 8 + depth * 12 },
      },
      React.createElement(open ? ChevronDown : ChevronRight, { size: 10 }),
      React.createElement("span", { className: "font-mono" }, name),
    ),
    open && renderChildren(kids, depth + 1),
  );
}

export default function TreeNode({ name, node, depth, activePath, onOpen, onDelete }) {
  function renderChildren(entries, nextDepth) {
    return entries.map(([k, v]) =>
      React.createElement(TreeNode, {
        key: k,
        name: k,
        node: v,
        depth: nextDepth,
        activePath,
        onOpen,
        onDelete,
      }),
    );
  }
  return (
    <Row
      name={name}
      node={node}
      depth={depth}
      activePath={activePath}
      onOpen={onOpen}
      onDelete={onDelete}
      renderChildren={renderChildren}
    />
  );
}
